<div class="upper bg_white_high_emphasis">
	<div class="container align_items_center gap_large">

        <a [routerLink]="routerService.HOME">
            <img class="logo" *atScreenResolution="'>= 960'" src="/assets/img/logos/ecotopia.svg" alt="HOME">            
		    <img class="logo_redux" *atScreenResolution="'< 960'" src="/assets/img/logos/ecotopia_redux.svg">
        </a>

		<mat-form-field class="search_field flex1 no_vertical_spacing">
			<input matInput type="text" [formControl]="search" (keydown.enter)="onSearch()" placeholder="Buscar productos, marcas y más..." name="search" autocapitalize="on"/>
			<mat-icon matPrefix>search</mat-icon>
		</mat-form-field>

		<div class="overflow_hidden justify_content_flex_end" *ngIf="!bLoggedIn" @expandLeft [@.disabled]="disableAnimationOnStartup">
			<button mat-flat-button color="primary" (click)="routerService.toLogin()">
				LOGIN
			</button>
		</div>
	</div>
</div>